import { z } from 'zod';

export const documentImageSchema = z.object({
  front: z.string().min(1),
  rear: z.string().min(1),
});

export const idSubmissionFormSchema = z.object({
  selfieImage: z.string(),
  documentImages: documentImageSchema,
  email: z.string().email(),
  termsAndConditionsAccepted: z.boolean().refine((val) => val === true, {
    message: 'U moet akkoord gaan met de algemene voorwaarden om door te gaan.',
  }),
});

export type IdSubmissionFormValues = z.infer<typeof idSubmissionFormSchema>;
